import HttpRequest from './core/http_request';
class SurveyProvider extends HttpRequest {
  getStatus () {
    return this.request('get', '/status');
  }

  // agra
  // waterQuality
  saveWaterQuality (data) {
    return this.request('post', '/private/survey/waterQuality', data);
  }

  getWaterQualityList (data) {
    return this.request('get', '/private/survey/waterQuality', data);
  }

  getWaterQuality (data) {
    return this.request('get', '/private/survey/waterQuality/id/' + data.id);
  }

  updateWaterQuality (data) {
    const id = data.id;
    delete data.id;
    return this.request('post', '/private/survey/waterQuality/id/' + id, data);
  }

  deleteWaterQuality (data) {
    return this.request('post', '/private/survey/waterQuality/delete/id/' + data.id);
  }

  saveWaterQualitySample (data) {
    const id = data.id;
    delete data.id;
    return this.request('post', '/private/survey/waterQuality/submitSample/id/' + id, data);
  }

  deleteWaterQualitySample (data) {
    return this.request('post', '/private/survey/waterQuality/deleteSample/id/' + data.id);
  }

  getMyWaterQualityList (data) {
    return this.request('get', '/private/survey/waterQuality/mySurvey', data);
  }

  getWaterQualityReport (data) {
    return this.request('get', '/private/survey/waterQuality/report', data);
  }

  getWaterSupplySurveyList (data) {
    return this.request('get', '/private/survey/waterSupply', data);
  }

  getWaterSupplySurvey (data) {
    return this.request('get', '/private/survey/waterSupply/id/' + data.id);
  }

  updateWaterSupplySurvey (data) {
    const payload = { ...data };
    const id = payload.id;
    delete payload.id;
    return this.request('post', '/private/survey/waterSupply/id/' + id, payload);
  }

  deleteWaterSupplySurvey (data) {
    return this.request('post', '/private/survey/waterSupply/delete/id/' + data.id);
  }

  getWaterSupplySampleList (data) {
    return this.request('get', '/private/survey/waterSupplySample', data);
  }

  getWaterSupplySample (data) {
    return this.request('get', '/private/survey/waterSupplySample/id/' + data.id);
  }

  updateWaterSupplySample (data) {
    const payload = { ...data };
    const id = payload.id;
    delete payload.id;
    return this.request('post', '/private/survey/waterSupplySample/id/' + id, payload);
  }

  deleteWaterSupplySample (data) {
    return this.request('post', '/private/survey/waterSupplySample/delete/id/' + data.id);
  }

  updateWaterQualityResearcher (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/private/survey/waterQuality/researcher/id/' + id, data);
  }

  // deleteSampleWaterQuality (data) {
  //   const id = data._id;
  //   delete data._id;
  //   return this.request('post', '/private/survey/waterQuality/deleteSample/id/' + id);
  // }
  // end waterQuality

  // soundMeasurement
  saveSoundMeasurement (data) {
    return this.request('post', '/private/survey/soundMeasurement', data);
  }

  getSoundMeasurementList (data) {
    return this.request('get', '/private/survey/soundMeasurement', data);
  }

  getSoundMeasurement (data) {
    return this.request('get', '/private/survey/soundMeasurement/id/' + data.id);
  }

  updateSoundMeasurement (data) {
    const id = data.id;
    delete data.id;
    return this.request('post', '/private/survey/soundMeasurement/id/' + id, data);
  }

  deleteSoundMeasurement (data) {
    return this.request('post', '/private/survey/soundMeasurement/delete/id/' + data.id);
  }

  getMySoundMeasurementList (data) {
    return this.request('get', '/private/survey/soundMeasurement/mySurvey', data);
  }

  // list screen Pruke
  getScreen (data) {
    return this.request('get', '/private/screen/my', data);
  }


  // end Pruke add 

  // end agra
}

export default SurveyProvider;
